<template>
	<!-- Content -->
	<div :class="{ 'opacity-50': status == 'feedback' }">

		<!-- Question -->
		<div class="m-auto" style="max-width: 700px;">
			<span class="h5" v-html="getText(question.id, 'text')"></span>
			<hr>
		</div>

		<!-- Elements -->
		<div class="d-flex mt-4 justify-content-center no-select">
			<div class="d-flex flex-wrap blockquote position-relative w-100">

				<div v-for="(group, gindex) in groups" :key="gindex" class="py-1" :class="{ 'col-6': groups.length%2==0, 'col-4': groups.length%2!=0 }">
					<div class="rounded-box m-1 p-3 h-100" style="background: #ECEFF1;">
						<span>{{ $t(groupIds[gindex]) }}</span>
						<hr>

						<draggable v-model="groups[gindex]" v-bind="dragOptions" group="mything" @start="drag=true; tryReset();" @end="drag=false" class="h-100 mx-3" :disabled="lockInput">
							<div v-for="(box,index) in group" :key="index" class="list-element d-flex">
								<div class="position-relative w-100 text-center">
									{{ getAnswerText(box.index) }}
									<input
									v-if="status != 'verify'"
									type="radio"
									role="button"
									style="position: absolute; left: -2em; top: 50%; transform: translate(-50%, -50%);"
									class="form-check-input"
									:class="{ 'checkbox-correct': box.styleCorrect, 'checkbox-incorrect': box.styleIncorrect }"
									checked>
								</div>
							</div>
						</draggable>
					</div>
				</div>

			</div>
		</div>

		<!-- Button and hint area -->
		<div v-if="status != 'feedback'" class="mt-4">
			<div class="m-auto" style="max-width: 700px;">
				<hr>
			</div>

			<!-- Help text -->
			<div class="mb-3">
				<div v-if="status == 'verify'" class="text-muted">
					<span>
						{{ $t('quiz_hint_sorting') }}
					</span>
				</div>
				<div v-if="status == 'try-again'" class="text-danger">
					<span>
						{{ $t('quiz_try_again') }}
					</span>
				</div>
				<div v-if="status == 'success'" class="text-success">
					<span>
						{{ $t('quiz_correct') }}
					</span>
				</div>
			</div>

			<!-- Answer button -->
			<div v-if="status == 'verify'">
				<button
					class="btn px-5 progress-bar-striped"
					:class="{ 'btn-primary': allowSubmit, 'btn-secondary': !allowSubmit, 'progress-bar-animated': allowSubmit }"
					@click="verify"
					:disabled="!allowSubmit">
					{{ $t('quiz_button_verify') }}
				</button>
			</div>
			<div v-else-if="status == 'try-again'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-danger"
					@click="tryAgain">
					{{ $t('quiz_button_try_again') }}
				</button>
			</div>
			<div v-else-if="status == 'success'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-success"
					@click="complete">
					{{ $t('continue') }}
				</button>
			</div>
		</div>
	</div>
</template>



<script>
import draggable from 'vuedraggable';
import Timer from '@/components/Timer';

export default {
	props: [ "question", "selectedIndex" ],
	components: { draggable },
	data() {
		return {
			id: null,
			status: null,
			lockInput: false,
			groups: [],
			answerIds: [],
			groupIds: [],
			numberOfGroups: 0,
			current: null,
			drag: false,
			previousAnswer: null,
			allowSubmit: false,

			timer: null,
		};
	},
	methods: {
		load(question) {
			this.id = question.id;
			// question.difficulty
			this.status = 'verify';
			this.lockInput = false;
			this.answerIds = question.answerIds;
			this.groupIds = question.groupIds;

			console.assert(question.correct.length == this.groupIds.length, "Mismatching groupIds and correct answers");

			this.groups = [];
			for (let i = 0; i < this.groupIds.length; i++) {
				this.groups.push([]);
			}

			for (let i = 0; i < question.answers.length; i++) {

				let g;
				for (g = 0; g < this.groups.length; g++) {
					if (question.correct[g].includes(question.answers[i])) {
						break;
					}
				}

				this.groups[g].push({
					index: question.answers[i],
					groupIndex: g,
					styleCorrect: false,
					styleIncorrect: false
				});

			}

			if (question.shuffle) {
				// Continue shuffling until order does not match the answer
				let limit = 100;
				do {
					let boxes = [].concat.apply([], this.groups);
					this.shuffle(boxes);

					for (const g in this.groups) {
						this.groups[g] = [];
					}

					let groupIndex = 0;
					while (boxes.length > 0) {
						this.groups[groupIndex].push(boxes.pop());
						groupIndex = (groupIndex + 1) % this.groups.length;
					}
				}
				while (this.needShuffle() && limit-- > 0)
			}

			this.allowSubmit = false;
			this.previousAnswer = this.currentAnswers;

			// Log new question
			if (!this.$tracker.isTaskComplete(this.id)) {
				this.$log.onQuestionStart(this.id, question.mechanic, this.selectedIndex+1, this.currentAnswers, question.correct);
				this.$tracker.onTaskStart(this.id);
			}
			// Auto-complete answers
			else {
				this.verify(null, true);
			}
		},
		needShuffle() {
			let count = 0;
			for (const g in this.groups) {
				for (const box of this.groups[g]) {
					if (box.groupIndex == g) {
						count += 1;
					}
				}
			}
			return (count > this.answerIds.length/2+1);
		},
		verify(event, autoComplete=false) {
			if (autoComplete) {
				let boxes = [].concat.apply([], this.groups);
				for (const g in this.groups) {
					this.groups[g] = boxes.filter(box => box.groupIndex == g);
				}
			}

			let allCorrect = true;

			for (const i in this.groups) {
				const group = this.groups[i];

				for (const j in group) {
					const box = group[j];
					const correct = (box.groupIndex == i);

					box.styleCorrect = correct;
					box.styleIncorrect = !correct;

					if (!correct) {
						allCorrect = false;
					}
				}
			}

			if (autoComplete) {
				this.status = 'feedback';
				this.lockInput = true;
			}
			else {
				this.$log.onQuestionVerify(this.id, this.currentAnswers, allCorrect);
				if (allCorrect) {
					this.status = 'success';
					this.$emit("complete");
					this.$log.onQuestionComplete(this.id);
					this.$tracker.onTaskComplete(this.id, this.timer.elapsed);
					this.lockInput = true;
				}
				else {
					this.status = 'try-again';
					// this.lockInput = true;
					this.$tracker.onTaskMistake();
				}
			}
		},
		complete() {
			this.status = 'feedback';
			this.$emit("progress");
			this.$log.onQuestionNext(this.id);
		},
		tryReset() {
			if (this.status == 'try-again') {
				this.tryAgain();
			}
		},
		tryAgain() {
			this.status = 'verify';
			this.lockInput = false;
			this.allowSubmit = false;
			this.$log.onQuestionTryAgain(this.id);

			for (let group of this.groups) {
				for (let box of group) {
					box.styleCorrect = false;
					box.styleIncorrect = false;
				}
			}
		},
		getAnswerText(index) {
			return this.getText(this.answerIds[index-1]);
			// return this.getText(this.question.id, 'answer_' + index);
		}
	},
	computed: {
		dragOptions() {
			return {
				animation: 100,
				group: "description",
				disabled: false,
			};
		},
		currentAnswers() {
			return this.groups.map(group => group.map(box => box.index));
		}
	},
	watch: {
		question(newData) {
			this.load(newData);
		},
		currentAnswers() {
			this.$log.onQuestionChangeAnswer(this.id, this.currentAnswers);
			if (this.previousAnswer != this.currentAnswers) {
				this.previousAnswer = null;
				this.allowSubmit = true;
			}
		}
	},
	mounted() {
		this.timer = new Timer();
		this.load(this.question);
	},
	beforeDestroy() {
		if (this.timer) {
			this.timer.clear();
		}
	}
};
</script>



<style scoped>
	.form-check-input {
		margin: 0;
		border-width: 2px;
		border-color: transparent !important;
	}


	.list-element {
		margin: 0.5rem 0;
		border: 1px solid gray;
		border-radius: 0.5em;
		padding: 0.5em 1em;
		font-size: 0.8em;
		background: white;
		box-shadow: 0 0.25rem 0.5rem rgb(0 0 0 / 10%);
	}
	.list-element:first-child { margin-top: 0; }
	.list-element:last-child { margin-bottom: 0; }
	.list-element:hover {
		background: #ECEFF1;
	}

	.fake {
		border-color: rgba(0, 0, 0, 0);
	}
</style>
